import {Component} from '@angular/core';

@Component({
  selector: 'xp-sensor',
  templateUrl: './sensor.component.html',
  styleUrl: './sensor.component.scss'
})
export class SensorComponent {

}
